import styled from 'styled-components';

export const FlatDatePickerButton = styled.button<{ isCalendarOpen: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    cursor: pointer;
    user-select: none;
    padding: 0.4rem 0.8rem;
    outline: none;
    border: none;
    background-color: transparent;

    svg {
        transition: transform 0.2s ease-out;
        transform: ${({ isCalendarOpen }) => (isCalendarOpen ? 'rotate(180deg)' : 'rotate(0deg)')};

        * {
            fill: ${({ theme }) => theme.colors.darkBlue};
        }
    }
`;
